import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
  sortStatus: "default",
  filterStatus: "all",
};

// create slice
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    changeSort: (state, action) => {
      state.sortStatus = action.payload;
    },
    changeFilter: (state, action) => {
      state.filterStatus = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { changeFilter, changeSort } = filterSlice.actions;
